package com.example.mystybag.appCore.model.pages

import com.example.mystybag.core.extensions.addDownloadLink
import com.example.mystybag.core.extensions.ifNotEmpty
import com.example.mystybag.core.extensions.separate
import com.example.mystybag.core.helpers.GlobalCommonData.getFirstNameValue
import com.example.mystybag.core.helpers.GlobalCommonData.getLastNameValue
import com.example.mystybag.core.expected.getVersionName
import com.example.mystybag.core.helpers.GlobalCommonData.getNumberOfReservationsValue
import com.example.mystybag.core.helpers.GlobalCommonData.getSavedAmountValue
import com.example.mystybag.core.helpers.GlobalCommonData.getUserImgUrlValue
import com.example.mystybag.core.model.IconDescription
import com.example.mystybag.core.model.ImageDescription
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p36

data class ProfilePageUIState(
    val firstName: String = getFirstNameValue(),
    val lastName: String = getLastNameValue(),
    val userImgUrl: String = getUserImgUrlValue(),
    val numberOfReservations: Int = getNumberOfReservationsValue(),
    val savedAmount: Double = getSavedAmountValue(),
    val userImage: ImageDescription = ImageDescription(
        link = getUserImgUrlValue().ifNotEmpty { it.addDownloadLink() },
        icon = IconDescription(
            resource = SRC.images.avatar_fill_icon,
            imageSize = p36
        )
    ),
    val userName: String = getFirstNameValue().separate(getLastNameValue()),
    val currentLanguage: String = "en",
    val appVersion: String = getVersionName().ifEmpty { "1.0.0" }
)

